import { createSlice } from '@reduxjs/toolkit';

export const homeDataSlice = createSlice({
	name: 'homepage',
	initialState: {
		banners: [],
		categories: [],
		accessories: [],
		newlaunches: [],
		productlist: [],
		landingData: [],
		aboutus: [],
		genetrateotp: [],
		homecategorysection: [],
		categoryinfo: [],
		storeconfig: [],
		categoryBreadcrumbs: [],
		categoryProducts: [],
		productDetails: [],
		subcategory: [],
		addtoproductcart: [],
		appliedCoupon: null,
		cartPrices: null,
		shippingAddresses: [],
		customerresult: [],
		wishlist: [],
		addproductwishlist: [],
		getcustomer: [],
		// getcomparelist: [],
		compareuidlist:[],
		createcomparelist: [],
		compareData:[],
		getaddresslist: [],
		getcategoryProduct: [],
		getcustomerorderlist: [],
		getorderdetail: [],
		getrelatedproduct:[],
		getShippingMethod:[],
		shippingAddress: {},
		getPaymentMethod:[],
		orderItems: {},
		selectedPaymentMethod:[],
		aboutUsData:[],
		cmsPage:[],
		country:[],
		blog:[],
		productDetailsLink: null,
		attributes: null,
		companyLogo: null

	},
	reducers: {
		// Redux Toolkit allows us to write "mutating" logic in reducers. It
		// doesn't actually mutate the state because it uses the immer library,
		// which detects changes to a "draft state" and produces a brand new
		// immutable state based off those changes,
		saveLogo: (state, action) => {
			state.companyLogo = action.payload;
		},
		saveCatagory: (state, action) => {
			state.categories = action.payload;
		},
		saveLandingCat: (state, action) => {
			state.landingCat = action.payload;
		},
		saveBanner: (state, action) => {
			state.banners = action.payload;
		},
		saveAccessories: (state, action) => {
			state.accessories = action.payload;
		},
		saveNewlaunches: (state, action) => {
			state.newlaunches = action.payload;
		},
		saveProductlist: (state, action) => {
			state.productlist = action.payload;
		},
		saveaboutus: (state, action) => {
			state.aboutus = action.payload;
		},
		savegenetrateotp: (state, action) => {
			state.genetrateotp = action.payload;
		},
		savehomecategorysection: (state, action) => {
			state.homecategorysection = action.payload;
		},

		savecatagoryinfo: (state, action) => {
			state.categoryinfo = action.payload;
		},
		savestoreconfig: (state, action) => {
			state.storeconfig = action.payload;
		},
		savelandingData: (state, action) => {
			state.landingData = action.payload;
		},

		savecategoryBreadcrumbs: (state, action) => {
			state.categoryBreadcrumbs = action.payload;
		},
		savecategoryProducts: (state, action) => {
			state.categoryProducts = action.payload;
		},
		saveproductDetails: (state, action) => {
			state.productDetails = action.payload;
		},
		savesubcategory: (state, action) => {
			state.subcategory = action.payload;
		},
		savewishlist: (state, action) => {
			state.wishlist = action.payload;
		},
		saveaddtoproductcart: (state, action) => {
			const {items, applied_coupons, prices, shipping_addresses} = action.payload;
			state.addtoproductcart = items;
			state.appliedCoupon = applied_coupons;
			state.cartPrices = prices;
			state.shippingAddresses = shipping_addresses;
		},
		savecustomerresult: (state, action) => {
			state.customerresult = action.payload;
		},
		saveaddproductwishlist: (state, action) => {
			state.addproductwishlist = action.payload;
		},
		savegetcustomer: (state, action) => {
			state.getcustomer = action.payload;
		},
		// savegetcomparelist: (state, action) => {
		// 	state.getcomparelist = action.payload;
		// },
		savecreatecomparelist: (state, action) => {
			state.createcomparelist = action.payload;
		},
		savecompareData: (state, action) => {
			state.compareData = action.payload;
		},
		savegetaddresslist: (state, action) => {
			state.getaddresslist = action.payload;
		},
		savecategoryProduct: (state, action) => {
			state.getcategoryProduct = action.payload;
		},
		savecustomerorderlist: (state, action) => {
			state.getcustomerorderlist = action.payload;
		},
		savegetorderdetail: (state, action) => {
			state.getorderdetail = action.payload;
		},
		
		savegetrelatedproduct: (state, action) => {
			state.getrelatedproduct = action.payload;
		},
		saveShippingMethod: (state, action) => {
			state.getShippingMethod = action.payload;
		},
		saveShippingAddress: (state, action) => {
			state.shippingAddress = action.payload;
		},
		saveAvailablePaymentMethod: (state, action) => {
			state.getPaymentMethod = action.payload;
		},
		saveSelectedPaymentMethod: (state, action) => {
			state.selectedPaymentMethod = action.payload;
		},
		saveAboutUsData: (state, action) => {
			state.aboutUsData = action.payload;
		},
		savecmsPage: (state, action) => {
			state.cmsPage = action.payload;
		},
		saveGetRegion: (state, action) => {
			state.country = action.payload;
		},
		saveOrderItems: (state, action) => {
			state.orderItems = action.payload;
		},
		saveBlog: (state, action) => {
			state.blog = action.payload;
		},	
		saveCompareUidList:	(state, action) => {
			state.compareuidlist = action.payload;
		},
		saveProductDetailsLink:(state, action)=> {
			state.productDetailsLink = action.payload
		},
		shareAttributes: (state, action)=> {
			state.attributes = action.payload
		},
		saveURLs: (state, action)=> {
			state.urlData = action.payload
		}
	},
});

export const {
	saveLogo,
	saveLandingCat,
	saveBanner,
	saveCatagory,
	saveAccessories,
	saveNewlaunches,
	saveProductlist,
	saveaboutus,
	savegenetrateotp,
	savehomecategorysection,
	savecatagoryinfo,
	savestoreconfig,
	savelandingData,
	savecategoryBreadcrumbs,
	savecategoryProducts,
	saveproductDetails,
	savesubcategory,
	saveaddtoproductcart,
	savecustomerresult,
	savewishlist,
	saveaddproductwishlist,
	savegetcustomer,
	savegetcomparelist,
	savecompareData,
	savecreatecomparelist,
	savegetaddresslist,
	savecategoryProduct,
	savecustomerorderlist,
	savegetorderdetail,
	savegetrelatedproduct,
	saveShippingMethod,
	saveShippingAddress,
	saveAvailablePaymentMethod,
	saveSelectedPaymentMethod,
	saveOrderItems,
	saveAboutUsData,
	savecmsPage,
	saveGetRegion,
	saveBlog,
	saveCompareUidList,
	saveProductDetailsLink,
	shareAttributes,
	saveURLs
	
} = homeDataSlice.actions;

export default homeDataSlice.reducer;
